/* global $ */

import 'slick-carousel';

const $reviews = $('.js-reviews');

const reviews = {
  initialize() {
    if ($reviews.length) {
      this.createSlider();
    }
  },

  createSlider() {
    $reviews.slick({
      rows: 0,
      arrows: false,
      cssEase: 'linear',
      infinite: true,
      autoplay: false,
      centerMode: true,
      mobileFirst: true,
      centerPadding: '0',
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            centerMode: false,
          },
        },
      ],
    });

    // Create interval to simulate slider autoplay...
    setInterval(() => {
      // Hide slides
      $reviews.find('.slick-slide').addClass('opacidown');

      // After the hide transition finishes we slide to the next slides
      setTimeout(() => {
        $reviews.slick('slickNext');
      }, 400);
    }, 8000);

    $reviews.on('afterChange', () => {
      $reviews.find('.slick-slide').removeClass('opacidown');
    });
  },
};

export default reviews;
